import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useWarningIcon } from 'kineticUtils/styles';

const useLockOverrideDialogStyles = makeStyles(({ spacing, palette }) => {
  const { warningIcon } = useWarningIcon(palette);
  return createStyles({
    warningIcon: { fontSize: spacing(4.5) },
    warningIconButton: {
      ...warningIcon,
    },
    warningDiv: {
      backgroundColor: '#faefde',
      borderRadius: spacing(),
      display: 'flex',
      alignContent: 'center',
      justifyContent: 'start',
      alignItems: 'center',
      textAlign: 'center',
      padding: spacing(2),
      marginBottom: spacing(2),
      color: palette.error.dark,
    },
  });
});

export default useLockOverrideDialogStyles;
